import React from "react";

const instructions = [
  {
    instruction:
      "This questionnaire is designed to help us understand you better and assess your fit for this job role. Please provide detailed answers.",
  },
  {
    instruction:
      "Following activities are strictly prohibited and will result in termination of this interview:",
    subInstructions: [
      "On starting this questionnaire, the screen will enter full screen mode. Exiting from this full screen mode is strictly prohibited.",
      "Copy and paste actions are disabled.",
      "Complete the questionnaire in a single session.",
    ],
  },
  {
    instruction:
      "Answer with your own knowledge and refrain from using any AI assistants, as this defeats the purpose of the evaluation.",
  },
  {
    instruction:
      "Your responses will be evaluated by an AI hiring assistant QualifyMe and the results will be available immediately.",
  },
  {
    instruction:
      "During the interview round, your webcam will be activated and your face will be recorded for monitoring and evaluation purposes.",
  },
];

const InstructionList: React.FC = () => {
  return (
    <ol style={{ lineHeight: "2", paddingLeft: "20px", width: "100%" }}>
      {instructions.map((item, index) => (
        <li key={index} className="instruction_list">
          {item.instruction.includes("QualifyMe") ? (
            <>
              Your responses will be evaluated by an AI hiring assistant{" "}
              <b>QualifyMe</b> and the results will be available immediately.
            </>
          ) : (
            item.instruction
          )}
          {item.subInstructions && (
            <ul
              style={{
                marginTop: "8px",
                paddingLeft: "20px",
                lineHeight: "1.8",
              }}
            >
              {item.subInstructions.map((sub, subIndex) => (
                <li key={subIndex}>{sub}</li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </ol>
  );
};

export default InstructionList;
